import React from "react";
import styles from "./Profile.module.css";
import { SubmitButton, TextComponent } from "../../components";
import profileImg from "../../assets/images/staticImages/profile.png";
import { useNavigate } from "react-router-dom";
import HeadingComponent from "../../components/HeadingComponent/HeadingComponent";
import HeaderComponent from "../../components/HeaderComponent/HeaderComponent";

const Profile = () => {
  const navigate = useNavigate();
  const role = localStorage.getItem("@role");

  return (
    <div className={styles.mainCon}>
      <HeaderComponent heading={"Profile"} />
      <div className={styles.SubMainCont}>
        <div className={styles.centerDiv}>
          <img src={profileImg} />
          <TextComponent text="Stacy Doe" className={styles.Heading} />
          <TextComponent
            text={"stacydoe@mail.com"}
            fontFamily={"Urbanist-medium"}
          />
          <TextComponent
            text={"(504) 896-9619"}
            fontFamily={"Urbanist-medium"}
          />
          {role == "admin" ? (
            <SubmitButton
              title={"Edit Profile"}
              onClick={() => navigate("/EditProfile")}
              btnContainerClass={styles.btnContainer}
              primary
              btnClass={`${styles.btn}`}
            />
          ) : role == "supervisor" ? (
            <>
              <TextComponent
                text={"Head Mixer"}
                fontFamily={"Urbanist-medium"}
              />
              <TextComponent
                text={"Supervisor"}
                fontFamily={"Urbanist-medium"}
              />
              <TextComponent
                text={"Mixing-Oven-Proof-Assembly"}
                fontFamily={"Urbanist-medium"}
              />
            </>
          ) : (
            <>
              <TextComponent text={"Staff Member"} fontFamily={"Urbanist-medium"} />
              <TextComponent
                text={"Mixing-Oven-Proof-Assembly"}
                fontFamily={"Urbanist-medium"}
              />
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default Profile;
